import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 8.5C7.77614 8.5 8 8.72386 8 9C8 9.27614 7.77614 9.5 7.5 9.5H1.5C1.22386 9.5 1 9.27614 1 9C1 8.72386 1.22386 8.5 1.5 8.5H7.5ZM10.5 5.5C10.7761 5.5 11 5.72386 11 6C11 6.27614 10.7761 6.5 10.5 6.5H1.5C1.22386 6.5 1 6.27614 1 6C1 5.72386 1.22386 5.5 1.5 5.5H10.5ZM10.5 2.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 11.333C10.3682 11.333 10.667 11.6318 10.667 12C10.667 12.3682 10.3682 12.667 10 12.667H2C1.63181 12.667 1.33301 12.3682 1.33301 12C1.33301 11.6318 1.63181 11.333 2 11.333H10ZM14 7.33301C14.3682 7.33301 14.667 7.63181 14.667 8C14.667 8.36819 14.3682 8.66699 14 8.66699H2C1.63181 8.66699 1.33301 8.36819 1.33301 8C1.33301 7.63181 1.63181 7.33301 2 7.33301H14ZM14 3.33301C14.3682 3.33301 14.667 3.63181 14.667 4C14.667 4.36819 14.3682 4.66699 14 4.66699H2C1.63181 4.66699 1.33301 4.36819 1.33301 4C1.33301 3.63181 1.63181 3.33301 2 3.33301H14Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5 14.167C12.9602 14.167 13.333 14.5398 13.333 15C13.333 15.4602 12.9602 15.833 12.5 15.833H2.5C2.03976 15.833 1.66699 15.4602 1.66699 15C1.66699 14.5398 2.03976 14.167 2.5 14.167H12.5ZM17.5 9.16699C17.9602 9.16699 18.333 9.53976 18.333 10C18.333 10.4602 17.9602 10.833 17.5 10.833H2.5C2.03976 10.833 1.66699 10.4602 1.66699 10C1.66699 9.53976 2.03976 9.16699 2.5 9.16699H17.5ZM17.5 4.16699C17.9602 4.16699 18.333 4.53976 18.333 5C18.333 5.46024 17.9602 5.83301 17.5 5.83301H2.5C2.03976 5.83301 1.66699 5.46024 1.66699 5C1.66699 4.53976 2.03976 4.16699 2.5 4.16699H17.5Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 8.5C7.77614 8.5 8 8.72386 8 9C8 9.27614 7.77614 9.5 7.5 9.5H1.5C1.22386 9.5 1 9.27614 1 9C1 8.72386 1.22386 8.5 1.5 8.5H7.5ZM10.5 5.5C10.7761 5.5 11 5.72386 11 6C11 6.27614 10.7761 6.5 10.5 6.5H1.5C1.22386 6.5 1 6.27614 1 6C1 5.72386 1.22386 5.5 1.5 5.5H10.5ZM10.5 2.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 11.333C10.3682 11.333 10.667 11.6318 10.667 12C10.667 12.3682 10.3682 12.667 10 12.667H2C1.63181 12.667 1.33301 12.3682 1.33301 12C1.33301 11.6318 1.63181 11.333 2 11.333H10ZM14 7.33301C14.3682 7.33301 14.667 7.63181 14.667 8C14.667 8.36819 14.3682 8.66699 14 8.66699H2C1.63181 8.66699 1.33301 8.36819 1.33301 8C1.33301 7.63181 1.63181 7.33301 2 7.33301H14ZM14 3.33301C14.3682 3.33301 14.667 3.63181 14.667 4C14.667 4.36819 14.3682 4.66699 14 4.66699H2C1.63181 4.66699 1.33301 4.36819 1.33301 4C1.33301 3.63181 1.63181 3.33301 2 3.33301H14Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5 14.167C12.9602 14.167 13.333 14.5398 13.333 15C13.333 15.4602 12.9602 15.833 12.5 15.833H2.5C2.03976 15.833 1.66699 15.4602 1.66699 15C1.66699 14.5398 2.03976 14.167 2.5 14.167H12.5ZM17.5 9.16699C17.9602 9.16699 18.333 9.53976 18.333 10C18.333 10.4602 17.9602 10.833 17.5 10.833H2.5C2.03976 10.833 1.66699 10.4602 1.66699 10C1.66699 9.53976 2.03976 9.16699 2.5 9.16699H17.5ZM17.5 4.16699C17.9602 4.16699 18.333 4.53976 18.333 5C18.333 5.46024 17.9602 5.83301 17.5 5.83301H2.5C2.03976 5.83301 1.66699 5.46024 1.66699 5C1.66699 4.53976 2.03976 4.16699 2.5 4.16699H17.5Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconLonger: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"longer"} {...props} />
);
